import { UPDATE_CHART_SETTINGS, RESET_CHART_SETTINGS } from './constants';
export var updateChartSettings = function updateChartSettings(settings) {
  return {
    type: UPDATE_CHART_SETTINGS,
    payload: settings
  };
};
export var resetChartSettings = function resetChartSettings() {
  return {
    type: RESET_CHART_SETTINGS
  };
};